<template>
    <div>
        <!-- Button trigger modal -->
        <a href="#" @click.prevent="abrir('MNL')" class="ml-3" data-toggle="tooltip" data-placement="left" title="Mensagens não lidas"
            v-if="$store.state.user.msg_nao_lidas && $store.state.user.msg_nao_lidas.length">
            <span class="badge badge-warning">
                <i class="fas fa-comment-dots mr-1"></i>
                {{ $store.state.user.msg_nao_lidas.length }}
            </span>
        </a>

        <!-- Button trigger modal -->
        <a href="#" @click.prevent="abrir('ON')" class="ml-3" data-toggle="tooltip" data-placement="left" title="Usuário Conectados">
            <span class="badge badge-primary">
                <i class="fa-solid fa-link-simple"></i>
            </span>
            <span class="badge badge-primary" v-if="false">{{ conectados }}</span>
        </a>
    </div>
</template>

<script>
export default {
    computed: { 
        conectados: function () { 
            return this.$store.state.conectados;
        }
    },

    methods: { 
        abrir(tipo) { 
            this.$emit('abrir', tipo);
        }
    }
}
</script>